import React from 'react';
import { Row, Card, CardBody, Col } from 'reactstrap';
import TicketPhotoGallery from '../../../Components/TicketPhotoGallery';

const TicketResultCard = ({
    firstRun,
    showCard,
    ticketID,
    ticketImages,
    carBrand,
    carModel,
    carPlate,
    ticketDateText,
    ticketTime,
    ticketAddress,
    ticketPriceToPay,
    ticketPrice7Days,
    ticketPrice30Days,
    ticketDateText7Days,
    ticketDateText30Days,
    ticketDaysPassed,
    paymodalFooter,
    publicPaymentSummary = false,
}) => (
    <Row>
        <Col md="12" xs="12" lg="12">
            <Card className={`paymodal-container animated   ${firstRun ? 'hideThis' : ''} ${!showCard ? 'fadeOutRight' : 'fadeInRight'}`} id="paymodalview" >
                <div className="pb-0 card-header header-paymodal text-center"><h5>{'Avis N° ' + ticketID}</h5></div>
                {publicPaymentSummary && ticketImages?.length > 0 && (
                    <div style={{ padding: 20 }}>
                        <TicketPhotoGallery images={ticketImages} imageClassName="paymodal-img" />
                    </div>
                )}
                {!publicPaymentSummary && (
                    <div className="row">
                        <div className="col-4 col-sm-4 col-xs-4">
                            <TicketPhotoGallery images={ticketImages} imageClassName="paymodal-img" />
                        </div>
                        <div className="col-8 col-sm-8 col-xs-8" style={{ marginLeft: 0, padding: 20 }}>
                            <h6 className="f-w-600 paymodal-car-title">{carBrand} {carModel}</h6>
                            <p>{carPlate}</p>
                        </div>
                    </div>
                )}
                <CardBody style={{ padding: 10 }}>
                    <div className="cal-desc text-left card-body card-paymodal">
                        {publicPaymentSummary ? (
                            <p className="f-w-600">État : Payable</p>
                        ) : (
                            <>
                                <h6 className="f-w-600">Contrôlé : </h6>
                                <p>Le {ticketDateText} à {ticketTime}</p>
                                <h6 className="f-w-600">Lieu : </h6>
                                <p>{ticketAddress}</p>
                                <div className="nav-tabs" style={{ marginTop: 20 }} />
                            </>
                        )}
                        <div className="row">
                            <div className="col-6 col-sm-6"> <h6 className="f-w-600">Montant : </h6></div>
                            <div className="col-6 col-sm-6"><h6 className="f-w-600 card-paymodal-price">{ticketPriceToPay} $ CA</h6></div>
                        </div>
                        {!publicPaymentSummary && (
                            <>
                                <p className={`datePriceUp ${ticketDaysPassed > 7 ? 'datePriceHasPassed' : ''}`}>*{ticketPrice7Days} $ CA après le {ticketDateText7Days}</p>
                                <p className={`datePriceUp ${ticketDaysPassed > 30 ? 'datePriceHasPassed' : ''}`}>*{ticketPrice30Days} $ CA après le {ticketDateText30Days}</p>
                            </>
                        )}
                        {paymodalFooter}
                    </div>
                </CardBody>
            </Card>
        </Col>
    </Row>
);

export default TicketResultCard;
